import {AfterViewChecked, Component, OnInit} from '@angular/core';
import {AdviserDetails} from "../api/fa-website-msrv/models/adviser-details";
import {ActivatedRoute} from "@angular/router";
import {Title} from "@angular/platform-browser";
import {TitleCasePipe} from "@angular/common";
import {FormBuilder} from "@angular/forms";
import {LeadNotificationRequest} from "../api/fa-website-msrv/models/lead-notification-request";
import {AdviserDetailsControllerService, SubmitLeadControllerService} from "../api/fa-website-msrv/services";
import {GoogleTagManagerService} from "../shared/google-analytics/google-analytics.service";

declare let jcf: any;
declare let jQuery;

@Component({
  selector: 'app-adviser-details',
  templateUrl: './adviser-details.component.html',
  styleUrls: ['./adviser-details.component.css'],
  providers: [GoogleTagManagerService]
})
export class AdviserDetailsComponent implements OnInit, AfterViewChecked {

  testimonialSliderConfig = {
    'prevArrow': '<button class="slick-prev slick-arrow pt-1" aria-label="Previous" type="button" style="display: block;">Previous</button>',
    'nextArrow': '<button class="slick-next slick-arrow pt-1" aria-label="Next" type="button" style="display: block;">Next</button>',
    'dots': true,
    'centerPadding': 60,
    'speed': 500,
    'slidesToShow': 1,
    'responsive': [
      {
        'breakpoint': 1440,
        'settings': {
          'slidesToShow': 1,
          'slidesToScroll': 1,
          'infinite': true,
          'dots': true
        }
      },
      {
        'breakpoint': 1024,
        'settings': {
          'slidesToShow': 1,
          'slidesToScroll': 1
        }
      },
      {
        'breakpoint': 789,
        'settings': {
          'slidesToShow': 1,
          'slidesToScroll': 1
        }
      }
    ]
  };
  adviserDetails: AdviserDetails;
  brokerIdentifier = "";
  isPhoneNumberDisplayed = false;
  isAdviserError = false;
  isFormSubmitted = false;
  isSubmitLeadError = false;
  isSubmitLoading = false;

  leadForm = this.formBuilder.group({
    productSelected: '',
    clientName: '',
    clientCellNumber: '',
    clientEmail: '',
  });

  constructor(private adviserDetailsControllerService: AdviserDetailsControllerService,
              private submitLeadControllerService: SubmitLeadControllerService,
              private route: ActivatedRoute,
              private titleService: Title,
              private titleCasePipe: TitleCasePipe,
              private formBuilder: FormBuilder,
              private googleTagManagerService: GoogleTagManagerService) {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.brokerIdentifier = params["adviserName"];
      this.adviserDetailsControllerService.adviserDetailsGet(this.brokerIdentifier).subscribe((response: AdviserDetails) => {
        this.adviserDetails = response;
        this.titleService.setTitle(this.titleCasePipe.transform(this.adviserDetails.adviserFullName) + " - Discovery");
      }, error => {
        this.isAdviserError = true;
        window.parent.location.href = '/portal/error-404-redesign';
      });
    });

  }

  ngAfterViewChecked(): void {
    this.reloadJcf();
  }

  onSubmit(): void {
    this.isSubmitLoading = true;
    let leadNotificationRequest: LeadNotificationRequest = {
      brokerName: this.adviserDetails.adviserFullName,
      brokerEmail: this.adviserDetails.adviserEmail,
      clientName: this.leadForm.value.clientName,
      clientNumber: this.leadForm.value.clientCellNumber,
      clientEmail: this.leadForm.value.clientEmail,
      clientProduct: this.leadForm.value.productSelected,
      documentName: this.brokerIdentifier
    };
    this.submitLeadControllerService.submitLeadPost(leadNotificationRequest).subscribe((response: number) => {
      this.isFormSubmitted = true;
      this.isSubmitLoading = false;
      if (response == null) {
        this.isSubmitLeadError = true;
      }
    }, error => {
      this.isFormSubmitted = true;
      this.isSubmitLoading = false;
      this.isSubmitLeadError = true;
    }, () => {
      this.googleTagManagerService.trackEventWithType('gtm.formSubmit', 'fa_website_callback');
    });
  }

  reloadJcf() {
    jQuery(() => {
      jcf.replaceAll();
      jcf.destroy(jQuery.find('select2 > select'));
      jQuery(jQuery.find('select2 > select')).addClass('jcf-ignore');
      jcf.refresh(document.getElementsByTagName('select2')[0]);
    });
  }

  scrollToSection(id) {
    if (id == 'fa-home') {
      window.parent.scrollTo({behavior: 'smooth', top: 0});
    } else {
      let el = document.getElementById(id);
      el.scrollIntoView({behavior: "smooth"});
    }
  }


}
